import { useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (event) => {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/password-reset/request", { email });
      setSent(true);
    } catch (requestError) {
      setError(requestError.response?.data?.detail || "Vi kunne ikke sende linket lige nu.");
    } finally {
      setBusy(false);
    }
  };

  return <div className="mx-auto max-w-xl px-4 py-12 sm:py-20">
    <section className="rounded-[28px] border border-brand-line bg-white p-6 shadow-[0_24px_70px_rgba(45,42,38,.08)] sm:p-10">
      <p className="text-xs font-bold uppercase tracking-[.16em] text-brand-fresh">Kontosikkerhed</p>
      <h1 className="mt-3 text-3xl font-bold text-brand-ink">Nulstil adgangskoden</h1>
      {sent ? <div className="mt-6 rounded-2xl bg-brand-soft p-5 text-sm leading-6 text-brand-green">
        Hvis e-mailen findes hos os, har vi sendt et link. Linket virker i 60 minutter og kan kun bruges én gang.
      </div> : <form onSubmit={submit} className="mt-7 space-y-5">
        <label className="block text-sm font-semibold text-brand-ink">E-mail
          <input type="email" required autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} className="mt-2 min-h-12 w-full rounded-xl border border-brand-line px-4 font-normal outline-none focus:border-brand-fresh focus:ring-4 focus:ring-brand-fresh/10"/>
        </label>
        {error && <div className="rounded-xl bg-[#FFF1EE] px-4 py-3 text-sm text-[#991B1B]" role="alert">{error}</div>}
        <button disabled={busy} className="btn-primary min-h-12 w-full rounded-xl">{busy ? "Sender…" : "Send nulstillingslink"}</button>
      </form>}
      <Link to="/log-ind" className="mt-6 inline-flex text-sm font-semibold text-brand-green underline underline-offset-4">Tilbage til login</Link>
    </section>
  </div>;
}

